const MOBILE_AGENT_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;

export const isMobileDevice = () =>
  MOBILE_AGENT_REGEX.test(navigator.userAgent);
